import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { dataTransform } from '@nexio/emvio-util-app';
import { toastIfError } from '../../utils/toast';
import Table from '../Table/Table';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { transformDateCell, transformNumberLocalizeCell } from '../../utils/cell';
import AgentResidualsListItem from './AgentResidualsListItem/AgentResidualsListItem';
import AgentResidualsWidget from './Widgets/AgentResidualsWidget/AgentResidualsWidget';
import {
    getAgentResidualsTotal,
    getIsAgentResidualsTotalLoading,
    getAgentResidualsTotalErrorMessage,
    getAgentResiduals,
    getIsAgentResidualsLoading,
    getAgentResidualsErrorMessage,
    getCount,
    getPages
} from './agentResidualsEntity';
import {
    getAgentResidualsTotal as fetchAgentResidualsTotal,
    getAgentResiduals as fetchAgentResiduals,
    fetchUrl
} from './agentResidualsActions';
import './AgentResiduals.scss';
import PropTypes from 'prop-types';
import {
    EmvioRow as Row
} from '@nexio/emvio-util-ui';

export class AgentResiduals extends Component {
    dateKey = 'reportDate';

    static propTypes = {
        agentResidualsTotal: PropTypes.shape({
            agentName: PropTypes.string,
            merchantCount: PropTypes.string,
            authCount: PropTypes.string,
            volume: PropTypes.string,
            income: PropTypes.string,
            expense: PropTypes.string,
            grossResiduals: PropTypes.string,
            agentResiduals: PropTypes.string
        }),
        isAgentResidualsTotalLoading: PropTypes.bool,
        error: PropTypes.string,
        onGetAgentResidualsTotalByAgentId: PropTypes.func,
        onGetAgentResidualsTotal: PropTypes.func,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        })
    };

    constructor(props) {
        super(props);

        this.state = {};

        this.defaultColumnsAndProps = [
            {
                accessor: 'type',
                filterable: true,
                label: 'Split Type',
                minWidth: 120,
                show: true,
                sortable: true
            },
            {
                accessor: 'mainRepCode',
                filterable: true,
                label: 'Main RepCode',
                minWidth: 145,
                show: true,
                sortable: true
            },
            {
                accessor: 'reportDate',
                Cell: transformDateCell,
                filterable: false,
                label: 'Residual Date',
                minWidth: 150,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'merchantId',
                filterable: true,
                label: 'Merchant ID',
                minWidth: 220,
                show: true,
                sortable: true
            },
            {
                accessor: 'merchantName',
                filterable: true,
                label: 'Merchant Name',
                minWidth: 190,
                show: true,
                sortable: true
            },
            {
                accessor: 'authCount',
                Cell: transformNumberLocalizeCell,
                filterable: false,
                label: 'Auth Count',
                minWidth: 130,
                show: true,
                sortable: true
            },
            {
                accessor: 'volume',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                label: 'Volume',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'income',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                label: 'Income',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'expense',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                label: 'Expense',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'grossResidual',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                label: 'Gross Residual',
                minWidth: 160,
                show: true,
                sortable: true
            },
            {
                accessor: 'splitPercent',
                filterable: true,
                label: 'Split',
                minWidth: 85,
                show: true,
                sortable: true
            },
            {
                accessor: 'agentResidual',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} />,
                filterable: false,
                label: 'Agent Residual',
                minWidth: 160,
                show: true,
                sortable: true
            }
        ];
    }

    componentDidUpdate(prevProps) {
        toastIfError(prevProps, this.props);
    }

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    renderAgentResidualsWidget = () => {
        return (
            <Row className="emvio-recovery-summary">
                <AgentResidualsWidget
                    residualsData={this.props.agentResidualsTotal}
                    isLoading={this.props.isAgentResidualsTotalLoading}
                />
            </Row>
        );
    };

    renderTableHeader = () => {
        return (
            <div className="disclaimer">Residual reports for the previous month are generated on the 20th of the current month</div>
        );
    };

    setDateAndFetchResiduals = (filters, page, pageSize, sorters, agentId, columns) => {
        this.props.onGetAgentResidualsTotalByAgentId(filters, this.props.match.params.id);

        return fetchAgentResiduals(filters, page, pageSize, sorters, agentId, columns);
    };

    render() {
        return (
            <div className="emvio-residuals">
                {this.renderAgentResidualsWidget()}
                <Table
                    fetchUrl={`${fetchUrl}/${this.props.match.params.id}`}
                    className="emvio-agent-residuals-table"
                    dateKey={this.dateKey}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: 'agentResidual'
                    }]}
                    HeaderComponent={this.renderTableHeader}
                    fetchData={(filters, page, pageSize, sorters) => this.setDateAndFetchResiduals(filters, page, pageSize, sorters, this.props.match.params.id)}
                    countSelector={getCount}
                    dataSelector={getAgentResiduals}
                    errorMessageSelector={getAgentResidualsErrorMessage}
                    isDataLoadingSelector={getIsAgentResidualsLoading}
                    pagesSelector={getPages}
                    itemKey="id"
                    hasNoCount={true}
                    ListItemComponent={AgentResidualsListItem}
                    noDataText="No Residuals Found"
                    shouldUseGlobalDate={false}
                    uniqueTableName="AgentResiduals"
                    getTableState={this.getTableState}
                    filterable={true}
                    shouldUseProvidedMerchantName={true}
                    alternatePicker="month" //when this is changed to day picker, remove the workaround in agentResidualActions
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        error: getAgentResidualsTotalErrorMessage(state),
        isAgentResidualsTotalLoading: getIsAgentResidualsTotalLoading(state),
        agentResidualsTotal: getAgentResidualsTotal(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetAgentResidualsTotalByAgentId: (filters, agentId) => dispatch(fetchAgentResidualsTotal(filters, agentId))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AgentResiduals));
